// Load locales
var gdprCookieNoticeLocales = {};

var isDirty = false;

function gdprCookieNotice(config) {
  var namespace = "gdprcookienotice";
  var pluginPrefix = "gdpr-cookie-notice";
  var templates = window[pluginPrefix + "-templates"];
  var gdprCookies = Cookies.noConflict();
  var modalLoaded = false;
  var noticeLoaded = false;
  var cookiesAccepted = false;
  var categories = ["performance", "analytics", "marketing"];

  // Default config options
  if (!config.locale) config.locale = "en";
  if (!config.timeout) config.timeout = 500;
  if (!config.domain) config.domain = null;
  if (!config.expiration) config.expiration = 30;
  if (!config.colorPrimary) config.colorPrimary = "rgb(26,213,108)";
  if (!config.colorSecondary) config.colorSecondary = "rgb(255,255,255)";
  if (!config.colorSecondary) config.cookiePoli = "rgb(255,255,255)";
  if (!config.policyLink) config.policyLink = "https://www.20scoops.com";

  // Get the users current cookie selection
  var currentCookieSelection = getCookie();
  var cookiesAcceptedEvent = new CustomEvent("gdprCookiesEnabled", {
    detail: currentCookieSelection
  });

  buildToggleButton();
  // showModal();

  var toggleButton = document.querySelector(
    "." + pluginPrefix + "-toggle-button"
  );

  function showToggleButton() {
    toggleButton.classList.add(pluginPrefix + "-toggle-button-open");
  }

  function hideToggleButton() {
    toggleButton.classList.remove(pluginPrefix + "-toggle-button-open");
  }

  toggleButton.addEventListener("click", function() {
    showNotice();
  });

  if (!currentCookieSelection || !currentCookieSelection[categories[1]]) {
    disableGoogleAnalytic();
  }

  // Show cookie bar if needed
  if (!currentCookieSelection) {
    showNotice();
    hideToggleButton();
    // Accept cookies on page scroll
    if (config.implicit) {
      acceptOnScroll();
    }
  } else {
    showToggleButton();
    toggleButton.classList.add(pluginPrefix + "-toggle-button-hide");
    window.setInterval(function() {
      deleteCookies(currentCookieSelection);
    }, 2000);
    document.dispatchEvent(cookiesAcceptedEvent);
  }

  buildNoticeOverlay();

  // Get gdpr cookie notice stored value
  function getCookie() {
    return gdprCookies.getJSON(namespace);
  }

  function enableGoogleAnalytic() {
    if (config[categories[1]]) {
      window["ga-disable-" + config[categories[1]]] = false;
      try {
        if (ga) {
          ga("send", "pageview");
        }
      } catch (e) {
        console.warn("cookie robot", e.message);
      }
    }
  }

  function disableGoogleAnalytic() {
    if (!config[categories[1]]) {
      return;
    }

    var notRemovedCookies = ["gdprcookienotice"];
    window["ga-disable-" + config[categories[1]]] = true;
    for (var i = 0; i < categories.length; i++) {
      if (i === 1) {
        continue;
      }

      if (config[categories[i]]) {
        for (var j = 0; j < config[categories[i]].length; j++) {
          notRemovedCookies.push(config[categories[i]][j]);
        }
      }
    }

    var allCookies = Object.keys(gdprCookies.get());

    for (var i = 0; i < allCookies.length; i++) {
      var isRemove = true;
      for (var j = 0; j < notRemovedCookies.length; j++) {
        if (allCookies[i] === notRemovedCookies[j]) {
          isRemove = false;
          break;
        }
      }
      if (isRemove) {
        gdprCookies.remove(allCookies[i]);
      }
    }
  }

  // Delete cookies if needed
  function deleteCookies(savedCookies) {
    for (var i = 0; i < categories.length; i++) {
      if (config[categories[i]] && !savedCookies[categories[i]]) {
        if (categories[i] === categories[1]) {
          // if it's google analytic, just skip it
          continue;
        }
        for (var ii = 0; ii < config[categories[i]].length; ii++) {
          gdprCookies.remove(config[categories[i]][ii]);
        }
      }
    }

    if (config[categories[1]] && savedCookies[categories[1]]) {
      enableGoogleAnalytic();
    } else if (config[categories[1]] && !savedCookies[categories[1]]) {
      disableGoogleAnalytic();
    }

    // Show the notice if not all categories are enabled
    // showNotice();/
  }

  // Hide cookie notice bar
  function hideNotice() {
    document.documentElement.classList.remove(pluginPrefix + "-loaded");
    window.setTimeout(function() {
      toggleButton.classList.add(pluginPrefix + "-toggle-button-hide");
    }, 3000);
    showToggleButton();
  }

  // Write gdpr cookie notice's cookies when user accepts cookies
  function acceptCookies(save) {
    var value = {
      date: new Date(),
      necessary: true,
      performance: true,
      analytics: true,
      marketing: true
    };

    // If request was coming from the modal, check for the settings
    if (save) {
      for (var i = 0; i < categories.length; i++) {
        value[categories[i]] = document.getElementById(
          pluginPrefix + "-cookie_" + categories[i]
        ).checked;
      }
    }
    gdprCookies.set(namespace, value, {
      expires: config.expiration,
      domain: config.domain
    });
    deleteCookies(value);

    // Load marketing scripts that only works when cookies are accepted
    cookiesAcceptedEvent = new CustomEvent("gdprCookiesEnabled", {
      detail: value
    });
    document.dispatchEvent(cookiesAcceptedEvent);
  }

  // Show the cookie bar
  function buildNotice() {
    if (noticeLoaded) {
      return false;
    }

    var noticeHtml = localizeTemplate("bar.html");
    document.body.insertAdjacentHTML("beforeend", noticeHtml);
    document
      .querySelector(".gdpr-cookie-notice-policy-link")
      .setAttribute("href", config.policyLink);

    // Load click functions
    setNoticeEventListeners();

    // Make sure its only loaded once
    noticeLoaded = true;
  }

  // Show the cookie notice
  function showNotice() {
    buildNotice();
    updateNoticeBarElementColor();
    hideToggleButton();
    // Show the notice with a little timeout
    toggleButton.classList.remove(pluginPrefix + "-toggle-button-hide");
    setTimeout(function() {
      document.documentElement.classList.add(pluginPrefix + "-loaded");
    }, config.timeout);
  }

  // Localize templates
  function localizeTemplate(template, prefix) {
    var str = templates[template];
    var data = gdprCookieNoticeLocales[config.locale];

    if (prefix) {
      prefix = prefix + "_";
    } else {
      prefix = "";
    }

    if (typeof str === "string" && data instanceof Object) {
      for (var key in data) {
        return str.replace(/({([^}]+)})/g, function(i) {
          var key = i.replace(/{/, "").replace(/}/, "");

          if (key == "prefix") {
            return prefix.slice(0, -1);
          }

          if (data[key]) {
            return data[key];
          } else if (data[prefix + key]) {
            return data[prefix + key];
          } else {
            return i;
          }
        });
      }
    } else {
      return false;
    }
  }

  function buildNoticeOverlay() {
    var html = '<div class="bar-overlay"></div>';
    document.body.insertAdjacentHTML("beforeend", html);
  }

  function buildToggleButton() {
    var toggleButtonHtml = localizeTemplate("toggle-button.html");

    document.body.insertAdjacentHTML("beforeend", toggleButtonHtml);

    var toggleButton = document.querySelector(
      "." + pluginPrefix + "-toggle-button button"
    );

    toggleButton.style.backgroundColor = config.colorPrimary;
  }

  // Build modal window
  function buildModal() {
    if (modalLoaded) {
      return false;
    }

    // Load modal template
    var modalHtml = localizeTemplate("modal.html");

    // Append modal into body
    document.body.insertAdjacentHTML("beforeend", modalHtml);

    // Get empty category list
    var categoryList = document.querySelector(
      "." + pluginPrefix + "-modal-cookies"
    );

    //Load essential cookies
    categoryList.innerHTML += localizeTemplate(
      "category.html",
      "cookie_essential"
    );
    var input = document.querySelector(
      "." + pluginPrefix + "-modal-cookie-input"
    );
    var label = document.querySelector(
      "." + pluginPrefix + "-modal-cookie-input-switch"
    );
    label.innerHTML = gdprCookieNoticeLocales[config.locale]["always_on"];
    label.classList.add(pluginPrefix + "-modal-cookie-state");
    label.classList.remove(pluginPrefix + "-modal-cookie-input-switch");
    input.remove();

    // Load other categories if needed
    categoryList.innerHTML += localizeTemplate(
      "category.html",
      "cookie_performance"
    );
    categoryList.innerHTML += localizeTemplate(
      "category.html",
      "cookie_analytics"
    );
    categoryList.innerHTML += localizeTemplate(
      "category.html",
      "cookie_marketing"
    );

    // Load click functions
    setModalEventListeners();

    // Update checkboxes based on stored info(if any)
    if (currentCookieSelection) {
      document.getElementById(pluginPrefix + "-cookie_performance").checked =
        currentCookieSelection.performance;
      document.getElementById(pluginPrefix + "-cookie_analytics").checked =
        currentCookieSelection.analytics;
      document.getElementById(pluginPrefix + "-cookie_marketing").checked =
        currentCookieSelection.marketing;
    }

    var radios = document.querySelectorAll(
      ".gdpr-cookie-notice-modal-cookie-input"
    );
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      radio.addEventListener("click", updateRadioOnModalElementColor);
    }

    // Make sure modal is only loaded once
    modalLoaded = true;
  }

  // Show modal window
  function showModal() {
    buildModal();
    document.documentElement.classList.add(pluginPrefix + "-show-modal");
    updateModalElementColor();
  }

  // Hide modal window
  function hideModal() {
    document.documentElement.classList.remove(pluginPrefix + "-show-modal");
    if (isDirty) {
      hideNotice();
    }
  }

  // Click functions in the notice
  function setNoticeEventListeners() {
    var acceptButton = document.querySelectorAll(
      "." + pluginPrefix + "-nav-item-accept"
    )[0];
    var manageButton = document.querySelectorAll(
      "." + pluginPrefix + "-manage"
    )[0];

    acceptButton.addEventListener("click", function(e) {
      e.preventDefault();
      acceptCookies();

      if (modalLoaded) {
        for (var i = 0; i < categories.length; i++) {
          document.getElementById(
            pluginPrefix + "-cookie_" + categories[i]
          ).checked = true;
        }
      }

      hideNotice();
    });

    manageButton.addEventListener("click", function() {
      showModal();
    });
  }

  // Click functions in the modal
  function setModalEventListeners() {
    var closeButton = document.querySelectorAll(
      "." + pluginPrefix + "-modal-close"
    )[0];
    var statementButton = document.querySelectorAll(
      "." + pluginPrefix + "-modal-footer-item-statement"
    )[0];
    var categoryTitles = document.querySelectorAll(
      "." + pluginPrefix + "-modal-cookie-title"
    );
    var saveButton = document.querySelectorAll(
      "." + pluginPrefix + "-modal-footer-item-save"
    )[0];

    closeButton.addEventListener("click", function() {
      hideModal();
      return false;
    });

    for (var i = 0; i < categoryTitles.length; i++) {
      categoryTitles[i].addEventListener("click", function() {
        this.parentNode.parentNode.classList.toggle("open");
        return false;
      });
    }

    saveButton.addEventListener("click", function(e) {
      e.preventDefault();
      saveButton.classList.add("saved");
      isDirty = true;
      setTimeout(function() {
        saveButton.classList.remove("saved");
      }, 1000);
      acceptCookies(true);
      hideModal();
    });
  }

  // Settings button on the page somewhere
  // var globalSettingsButton = document.querySelectorAll(
  //   "." + pluginPrefix + "-nav-item-settings"
  // );
  // if (globalSettingsButton) {
  //   for (var i = 0; i < globalSettingsButton.length; i++) {
  //     globalSettingsButton[i].addEventListener("click", function(e) {
  //       e.preventDefault();
  //       showModal();
  //       console.log("modal!");
  //     });
  //   }
  // }

  // Get document height
  function getDocHeight() {
    var D = document;
    return Math.max(
      D.body.scrollHeight,
      D.documentElement.scrollHeight,
      D.body.offsetHeight,
      D.documentElement.offsetHeight,
      D.body.clientHeight,
      D.documentElement.clientHeight
    );
  }

  // Check if at least page is 25% scrolled down
  function amountScrolled() {
    var winheight =
      window.innerHeight ||
      (document.documentElement || document.body).clientHeight;
    var docheight = getDocHeight();
    var scrollTop =
      window.pageYOffset ||
      (document.documentElement || document.body.parentNode || document.body)
        .scrollTop;
    var trackLength = docheight - winheight;
    var pctScrolled = Math.floor((scrollTop / trackLength) * 100); // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)
    if (pctScrolled > 25 && !cookiesAccepted) {
      cookiesAccepted = true;
      return true;
    } else {
      return false;
    }
  }

  // Accept cookies on scroll
  function acceptOnScroll() {
    window.addEventListener("scroll", function _listener() {
      if (amountScrolled()) {
        acceptCookies();
        window.removeEventListener("click", _listener);
      }
    });
  }

  // change color from config
  function updateNoticeBarElementColor() {
    var btnAccept = document.querySelector(".gdpr-cookie-notice-nav-item-btn");
    var policyLink = document.querySelector(".gdpr-cookie-notice-policy-link");
    var manageCookie = document.querySelector(".gdpr-cookie-notice-manage");
    var dividerLink = document.querySelector(
      ".gdpr-cookie-notice-divider-link"
    );

    btnAccept.style.background = config.colorPrimary;
    policyLink.style.color = config.colorPrimary;
    manageCookie.style.color = config.colorPrimary;

    var cookieNotice = getCookie();

    if (!config.policy) {
      policyLink.style.display = "none";
      dividerLink.style.display = "none";
    } else {
      policyLink.style.display = "inline";
      dividerLink.style.display = "inline-block";
      policyLink.setAttribute("href", config.policy);
    }
  }

  function updateModalElementColor() {
    var btnModalAccept = document.querySelector(
      ".gdpr-cookie-notice-modal-footer-item-btn"
    );
    btnModalAccept.style.background = config.colorPrimary;
    updateRadioOnModalElementColor();
  }

  function updateRadioOnModalElementColor() {
    var radioBoxShadow = "inset 0px 0px 0px 2px " + config.colorPrimary;
    var uncheckedRadios = document.querySelectorAll(
      ".gdpr-cookie-notice-modal-cookie-input + .gdpr-cookie-notice-modal-cookie-input-switch"
    );
    for (var i = 0; i < uncheckedRadios.length; i++) {
      var radio = uncheckedRadios[i];
      radio.style.background = null;
      radio.style.boxShadow = radioBoxShadow;
    }

    var checkedRadios = document.querySelectorAll(
      ".gdpr-cookie-notice-modal-cookie-input:checked + .gdpr-cookie-notice-modal-cookie-input-switch"
    );
    for (var i = 0; i < checkedRadios.length; i++) {
      var radio = checkedRadios[i];
      radio.style.background = config.colorPrimary;
      radio.style.boxShadow = radioBoxShadow;
    }
  }
}
